export const getButtonStyles = (isActive: boolean) => ({
  backgroundColor: isActive ? '#DFFFD6' : '#fff',
  color: '#000',
  height: '40%',
  boxShadow: 'none',
  whiteSpace: 'nowrap',
  maxWidth: '160px',
  padding: '8px 16px',
});

export const nameDateStyle = { fontSize: '12px', color: '#C3C3C3', display: 'flex', flexDirection: 'column', alignItems: 'start' };
export const columns = { whiteSpace: 'pre-line' };
